<template>
  <div class="tab-height-div">
    <Spin fix v-if="isLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Table border :columns="columns" :data="dataArr">
      <template slot-scope="{ row,index }" slot="key" style="color: darkred">
        <Checkbox v-if="editDisabled"  v-model="dataArr[index]['isKey']"
                  :disabled="!(disabled === dataArr[index]['isKey'])"
                  @on-change="keyChange"></Checkbox>

        <Checkbox v-else  v-model="dataArr[index]['isKey']"
                  disabled></Checkbox>
      </template>
    </Table>
  </div>
</template>

<script>
  import Util from '@/libs/util.js';

  export default {
    name: "FormData",
    data() {
      let t = this;
      return {
        //   dataArr: [],
        isLoading:true,
        editDisabled: true,
        disabled: false,
        dbArr: [],
        columns: [
          {
            title: "字段名称",
            key: "name",
            render: (h, params) => {
            return h(
              "div",
              { class: params.row["fieldName"] ? "" : "ctName" },
              [
                h("Input", {
                  props: {
                    value: params.row.fieldName
                  },
                  class: "ctinpt",
                  on: {
                    "on-blur": event => {
                    this.dataArr[params.index].fieldName = event.target.value;
      this.$store.commit("setInfo", this.dataArr);
      this.$emit("handleTitle", this.dataArr);
    }
    }
    }),
      h(
        "div",
        {
          style: {
            color: "red",
            display:
              params.row.fieldName === "" ||
              params.row.fieldName === null
                ? "inline-block"
                : "none"
          },
          class: "cxname"
        },
        [
          h("Icon", {
            props: {
              type: "ios-alert"
            }
          }),
          h("Font", { style: { color: "red" } }, "字段名称必填")
        ]
      )
    ]
    );
    }
    },
      {
        title: "字段备注",
          key: "marker",
        render: (h, params) => {
        return h("Input", {
          props: {
            value: params.row.content
          },
          on: {
            "on-blur": event => {
            this.dataArr[params.index].content = event.target.value;
      }
      }
      });
      }
      },
      {
        title: "字段长度",
          key: "length",
        render: (h, params) => {
        return h(
          "div",
          {
            class:
              (params.row["type"] == 6 ||
                params.row["type"] == 7 ||
                params.row["type"] == 8) &&
              !params.row["length"]
                ? "ctName"
                : ""
          },
          [
            h("Input", {
              props: {
                value: params.row.length
              },
              class: "ctinpt",
              on: {
                "on-blur": event => {
                this.dataArr[params.index].length = event.target.value;
      }
      }
      }),
        h(
          "div",
          {
            style: {
              color: "red",
              display:
                (params.row["type"] == 6 ||
                  params.row["type"] == 7 ||
                  params.row["type"] == 8) &&
                !params.row["length"]
                  ? "inline-block"
                  : "none"
            },
            class: "cxname"
          },
          [
            h("Icon", {
              props: {
                type: "ios-alert"
              }
            }),
            h("Font", { style: { color: "red" } }, "字段长度必填")
          ]
        )
      ]
      );
      }
      },
      {
        title: "小数点",
          key: "point",
        render: (h, params) => {
        return h(
          "div",
          {
            class:
              (params.row["type"] == 6 ||
                params.row["type"] == 7 ||
                params.row["type"] == 8) &&
              !params.row["pointLength"]
                ? "ctName"
                : ""
          },
          [
            h("Input", {
              props: {
                value: params.row.pointLength
              },
              class: "ctinpt",
              on: {
                "on-blur": event => {
                this.dataArr[params.index].pointLength =
                event.target.value;
      }
      }
      }),
        h(
          "div",
          {
            style: {
              color: "red",
              bottom: "21px",
              display:
                (params.row["type"] == 6 ||
                  params.row["type"] == 7 ||
                  params.row["type"] == 8) &&
                !params.row["pointLength"]
                  ? "inline-block"
                  : "none"
            },
            class: "cxname"
          },
          [
            h("Icon", {
              props: {
                type: "ios-alert"
              }
            }),
            h("Font", { style: { color: "red"} }, "小数点必填")
          ]
        )
      ]
      );
      }
      },
      {
        title: "默认值",
          key: "default",
        render: (h, params) => {
        return h("Input", {
          props: {
            value: params.row.defaultValue
          },
          on: {
            "on-blur": event => {
            this.dataArr[params.index].defaultValue = event.target.value;
      }
      }
      });
      }
      },
      {
        title: "字段类型",
          width: 150,
        key: "type",
        render: (h, params) => {
        return h(
          "div",
          {
            class: params.row["type"] ? "" : "ctName"
            // style: { display: "flex", flexDirection: "column" }
          },
          [
            h(
              "Select",
              {
                props: {
                  transfer: true,
                  value: params.row.type,
                  filterable:true
                },
                class: "ctinpt",
                on: {
                  "on-change": event => {
                  this.dataArr[params.index].type = event;
        this.typeChange(params.index);
      }
      }
      },
        this.dbArr.map(item => {
          return h("Option", {
            props: {
              value: item.typeNum,
              label: item.typeName
            }
          });
      })
      ),
        h(
          "div",
          {
            style: {
              color: "red",
              display: !params.row["type"] ? "inline-block" : "none"
            },
            class: "cxnameselect"
          },
          [
            h("Icon", {
              props: {
                type: "ios-alert"
              }
            }),
            h("Font", { style: { color: "red" } }, "字段类型必填")
          ]
        )
      ]
      );
      }
      },
      {
        title: "允许空值",
          width: 100,
        align: "center",
        key: "empty",
        render: (h, params) => {
        return h("Checkbox", {
          props: {
            value: params.row.isNull
          },
          on: {
            "on-change": event => {
            this.dataArr[params.index].isNull = event;
        // this.typeChange(params.index);
      }
      }
      });
      }
      },
      {
        title: "是否为主键",
          width: 110,
        align: "center",
        slot: "key",
        renderHeader: (h, params) => {
        let isKeySelectFlag = false;
        let allRows = this.dataArr;
        let len = allRows.length;
        for (let i = 0; i < len; i++) {
          let isKey = allRows[i].isKey;
          if (true === isKey || isKey == 1) {
            isKeySelectFlag = true;
          }
        }
        if (isKeySelectFlag) {
          return h("span", "是否为主键");
        } else {
          return h("div", [
            h(
              "span",
              {
                style: {
                  color: "#ff0000"
                }
              },
              "是否为主键"
            ),
            h(
              "font",
              {
                style: {
                  color: "#ff0000"
                }
              },
              "*"
            )
          ]);
        }
      },
      },
      {
        title: "排序",
          key: "order",
        render: (h, params) => {
        return h("Input", {
          props: {
            value: params.row.orderNum
          },
          on: {
            "on-blur": event => {
            this.dataArr[params.index].orderNum = event.target.value;
      }
      }
      });
      }
      },
      {
        title: "操作",
          slot: "action",
        render: (h, params) => {
        let index = params.index;
        let length = this.dataArr.length;
        // console.log(index);
        // console.log(length);
        if (index != length - 1) {
          return h("Button", {
            props: {
              type: "error",
              size: "small",
              icon: "md-remove"
            },
            on: {
              click: () => {
              this.remove(params.index);
        }
        }
        });
        }
        return h("div", [
          h("Button", {
            props: {
              type: "primary",
              size: "small",
              icon: "md-add"
            },
            style: {
              marginRight: "5px"
            },
            on: {
              click: () => {
              this.add(params.index);
      }
      }
      }),
        h("Button", {
          props: {
            type: "error",
            size: "small",
            icon: "md-remove"
          },
          on: {
            click: () => {
            this.remove(params.index);
      }
      }
      })
      ]);
      }
      }
    ],
      tempDatalist: [],
        dataArr: [{fieldName: '',
        content: '',
        length: '',
        pointLength: '',
        defaultValue: '',
        type: '',
        isNull: false,
        isKey: false,
        orderNum: 1,
        isShow: false,
        isShowList: false,
        fieldLength: 320,
        isQuery: false,
        queryMode: null,
        showType: null}]
    };
    },
    props: {
      // dataArr: Array,
      dbType: Number,
      isData: {}
    },
    mounted() {
      this.listDbType(this.dbType);
    },
    computed: {
      currentData() {
        return this.$store.state.tabdata.info;
      }
    },
    watch: {
      dbType(value, old) {
        this.listDbType(value);
      },
      currentData(v) {
        setTimeout(() => {
          this.dataArr = this.$store.state.tabdata.info;
        // this.isLoading = false;
      }, 20);
      }
    },
    methods: {
      add() {
        let max = 1;
        let orderArr = [];
        for (let i = 0; i < this.dataArr.length; i++) {
          orderArr.push(this.dataArr[i].orderNum);
        }
        if (orderArr.length > 0) {
          max = Math.max.apply(null, orderArr);
          max++;
        }
        let map = {
          id: null,
          formTable: null,
          fieldName: "",
          content: "",
          length: "",
          pointLength: "",
          defaultValue: "",
          type: "",
          isNull: false,
          isKey: false,
          orderNum: max,
          isShow: false,
          isShowList: false,
          fieldLength: 320,
          isQuery: false,
          queryMode: null,
          showType: null
        };
        this.dataArr.push(map);
        this.$store.commit("setInfo", this.dataArr);
      },
      listDbType(value) {
        let This = this;
        if (value !== null) {
          const [url,param] = [
            '/api/fieldTypes', {
              params: {
                dbType: value
              }
            }
          ]
          This.$http.get(url,param).then(function(response) {
            This.dbArr = response.data;
          })
            .catch(function(error) {
              console.log(error);
            });
        }
      },
      remove(index) {
        var rowInfo = this.dataArr[index];
        var isKey = rowInfo.isKey;
        if (true === isKey) {
          this.disabled = false;
          this.editDisabled = true;
        }
        this.dataArr.splice(index, 1);
        this.$store.commit("setInfo", this.dataArr);
        this.$emit("handleTitle", this.dataArr);
        if (this.dataArr.length === 0) {
          this.disabled = false;
          this.editDisabled = true;
          this.add();
        }
      },
      keyChange(flag) {
        this.disabled = flag;
        this.$emit("handleTitle", this.dataArr)
      },
      typeChange(index) {}
    }
  };
</script>
<style>
  .tab-height-div {
    height: calc(100vh - 180px);
    overflow: auto;
  }
  .ctName {
    height: 115px;
    position: relative;
    /* display: flex;
    flex-direction: column */
  }
  .ctName .ctinpt {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .ctName .cxname {
    position: absolute;
    bottom: 3px;
  }

  .cxnameselect {
    position: absolute;
    bottom: 21px;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
</style>

